import { toggleItems } from '@src/components/toggleItems';
import { changeHeaderBackgroundTo } from './changeHeaderBackgroundTo';
import { ScreensInt } from '@tailwindConfig/screens.config';

document.addEventListener('DOMContentLoaded', (event) => {
  const html = document.querySelector('html');
  const body = document.querySelector('body');
  const sections = document.querySelectorAll('.base-page > section, .alt-page > section');
  const header = document.querySelector('header');

  // Change header background-color accordingly to the section on it
  const headerBackgroundColor = (section) => {
    if (window.scrollY > (section.offsetTop - header.offsetHeight) && window.scrollY < (section.offsetTop + section.offsetHeight - header.offsetHeight)) {
      const backgroundColor = window.getComputedStyle(section).backgroundColor;
      if (backgroundColor === 'rgba(0, 0, 0, 0)' || !backgroundColor) {
        changeHeaderBackgroundTo('white', backgroundColor);
      } else if (backgroundColor === 'rgb(29, 29, 27)') {
        changeHeaderBackgroundTo('black', backgroundColor);
      } else if (backgroundColor === 'rgb(0, 0, 0)') {
        changeHeaderBackgroundTo('dark', backgroundColor);
      } else {
        changeHeaderBackgroundTo('otherColor', backgroundColor);
      }
    }
  };

  if (sections.length > 0) {
    headerBackgroundColor(sections[0]);
    sections.forEach(section => {
      window.addEventListener('scroll', () => {
        headerBackgroundColor(section);
      });
    });
  }

  // stop dropdown transition and change overflow if burger menu is open on resize
  const dropdowns = document.querySelectorAll('header nav .toggle-content');
  const containerDropdown = document.querySelector('header nav ul');

  let windowWidth = window.innerWidth;
  let timer = null;
  $(window).on('resize', function () {
    clearTimeout(timer);
    dropdowns.forEach(dropdown => dropdown.classList.add('stop-transition'));
    containerDropdown.classList.add('stop-transition');
    timer = setTimeout(() => {
      if (windowWidth !== window.innerWidth) {
        if (!window.matchMedia(`(max-width: ${ScreensInt.lg}px)`).matches) {
          body.style.overflow = '';
          html.style.overflow = '';
        } else if (header.querySelector('.burger-menu.open')) {
          body.style.overflow = 'hidden';
          html.style.overflow = 'hidden';
        }
        dropdowns.forEach(dropdown => dropdown.classList.remove('stop-transition'));
        containerDropdown.classList.remove('stop-transition');
        windowWidth = window.innerWidth;
      }
    }, 100);
  });

  // Burger Menu
  const listItems = document.querySelector('header .left-element > ul');
  const burgerMenu = document.querySelector('header .burger-menu');
  if (burgerMenu) {
    burgerMenu.addEventListener('click', () => {
      burgerMenu.classList.toggle('open');
      listItems.classList.toggle('open');
      const bodyOverflowHidden = body.style.overflow === 'hidden';
      if (bodyOverflowHidden) {
        body.style.overflow = '';
        html.style.overflow = '';
      } else {
        body.style.overflow = 'hidden';
        html.style.overflow = 'hidden';
      }
    });

    const $items = $('header nav li.toggle-item');

    toggleItems($items, true, false);

    // show lang dropdown
    const langSwitchContainers = header.querySelectorAll('.lang-switch-container');
    langSwitchContainers.forEach(langSwitchContainer => {
      const langSwitcher = langSwitchContainer.querySelector('.lang-switcher');
      langSwitcher.addEventListener('click', (event) => {
        const dropdown = langSwitchContainer.querySelector('.lang-drop-switch');
        if (!dropdown) return;
        event.preventDefault();
        langSwitcher.classList.toggle('active');
        dropdown.classList.toggle('active');
        langSwitcher.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
        event.stopPropagation();
      });
    });

    // remove lang dropdown when clicking outside of it
    document.addEventListener('click', (event) => {
      langSwitchContainers.forEach(langSwitchContainer => {
        const dropdown = langSwitchContainer.querySelector('.lang-drop-switch');
        const isClickInside = dropdown.contains(event.target);

        if (!isClickInside) {
          const langSwitcher = langSwitchContainer.querySelector('.lang-switcher');
          const dropdown = langSwitchContainer.querySelector('.lang-drop-switch');
          langSwitcher.classList.remove('active');
          dropdown.classList.remove('active');
        }
      });
    });
  }

  // Prevent Onboarding Team if the banner is active
  const navBar = document.querySelector('nav');
  const banner = document.querySelector('.top-bar');
  if (banner && !banner.classList.contains('hidden') && banner.innerText == 'Offre spéciale Indépendants. 2 mois offerts sur la Carte X avec le code promo QONTO2X.') {
    if (navBar) {
      const primaryBtn = navBar.querySelector('.primary');
      if (primaryBtn) {
        primaryBtn.href += '?promo=metal';
      }
    }
  }
});
